import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/act-snippets/",
          "title": "Snippet page structure and configuration"
        }}>{`A snippet`}</MDXTag>{` of a typical snippet page`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-markdown"
        }}>{`---
title:  The frontmatter field containing a snippet title
keywords: used for SEO
menu: group name/snippet name (slash separated group and snippet names)
---

Some snippet content
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`And a snippet collection configuration (shared by all snippets in the collection)`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-yaml"
        }}>{`# a sidebar menu (snippet groups)
menu:
  - text: group name 1
    icon: group icon 1
  - text: group name 2
    icon: group icon 2
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "ACT - a snippet page structure and collection configuration",
  "keywords": "ACT, snippet page",
  "menu": "act blog/snippets"
};
    